export default __webpack_public_path__ + "static/media/marshcoffee.5a244bad.jpg";